<svg
  width="22"
  height="22"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.8235 0.114641C10.896 -0.0382137 11.104 -0.0382136 11.1765 0.114641L14.3604 6.82192C14.3898 6.88385 14.4467 6.92626 14.5122 6.93493L21.8273 7.90426C21.9943 7.92639 22.0598 8.14365 21.9353 8.26245L16.5953 13.3582C16.5444 13.4067 16.5213 13.4796 16.5343 13.5504L17.8765 20.8368C17.9078 21.0067 17.7383 21.1394 17.5919 21.0595L11.091 17.5127C11.034 17.4815 10.966 17.4815 10.909 17.5127L4.40805 21.0595C4.26172 21.1394 4.09218 21.0067 4.12347 20.8368L5.46565 13.5504C5.4787 13.4796 5.45562 13.4067 5.40474 13.3582L0.0647221 8.26245C-0.0597763 8.14365 0.00571654 7.92639 0.172697 7.90426L7.48783 6.93493C7.55326 6.92626 7.61023 6.88385 7.63963 6.82192L10.8235 0.114641Z"
  />
</svg>

<style>
  svg path {
    fill: var(--vlt-lp-accent);
  }
</style>
